<template>
<v-content>
    <v-toolbar flat dense>
        <v-toolbar-title>Адреси виконавців</v-toolbar-title>
        <v-btn icon @click="getDataFromApi()" title="Оновити">
            <v-icon color="grey">cached</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field @keyup.enter="getDataFromApi()" flat hide-details prepend-inner-icon="search" label="Пошук" v-model="query"></v-text-field>
        <v-autocomplete @change="getDataFromApi()" clearable hide-details label="Місто" v-model="city" :loading="loadingCity" :items="itemsCity" :search-input.sync="searchCity" cache-items flat hide-no-data></v-autocomplete>

        <v-spacer></v-spacer>
    </v-toolbar>
    <div style="height: 0px; display: block; position: absolute; width: 100%;">
        <v-progress-linear color="blue" :indeterminate="true" v-if="loading"></v-progress-linear>
    </div>

    <v-data-table disable-initial-sort :headers="filteredHeaders" :items="list" :rows-per-page-items="rowsPerPageItems" rows-per-page-text="на стор." :pagination.sync="pagination" :total-items="totalList" class="elevation-1">
        <template slot="items" slot-scope="props">
            <tr :bgcolor="props.item.statusColor" @dblclick="$router.push('/partners/contractors_addresses/card/'+ props.item.id)">
                <td v-for="(col,index) in headers" v-if="headers[index].selected" :class="'text-xs-'+headers[index].align">
                    {{ props.item[col.value] }}
                </td>
                <td>
                    <v-icon small @click="deleteItem(props.item)">
                        delete
                    </v-icon>
                </td>
            </tr>

        </template>
        <template v-slot:no-data>
            немає даних
        </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
        <v-icon color="white">{{snackbarIcon}}</v-icon> {{snackbarText}}
    </v-snackbar>
</v-content>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {

    data() {
        return {
            menu: false,
            message: false,
            error: [],
            totalList: 0,
            list: [],
            loading: false,
            pagination: {},
            rowsPerPageItems: [5, 10, 20],

            search: null,
            city: null,
            loadingCity: false,
            itemsCity: [],
            searchCity: null,

            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            snackbarIcon: '',
            timeout: 6000,


            query: null,
            headers: [{
                    text: 'Номер',
                    align: 'left',
                    sortable: true,
                    value: 'id',
                    selected: true
                },
                {
                    text: 'Виконавець',
                    value: 'contractorName',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'Місто',
                    value: 'cityName',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'Адреса',
                    value: 'address',
                    selected: true,
                    sortable: true,
                },
            ]

        }
    },

    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true
        },
        searchCity(val) {
            val && val !== this.select && this.querySelectionsCity(val)
        }

    },
    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                this.totalList == null
            ) return 0

            return Math.ceil(this.totalList / this.pagination.rowsPerPage)
        },
        filteredHeaders() {
            return this.headers.filter(h => h.selected)
        },
    },
    mounted() {
        const self = this
        this.$root.$on('reloadContractorsAddressesTable', function () {
            self.getDataFromApi()
        })
    },
    created() {
        if (!localStorage.paginationContractorsAddresses || localStorage.paginationContractorsAddresses == '') {
            localStorage.paginationContractorsAddresses = '{}'
        }
        this.pagination = this.getLocalStorage('paginationContractorsAddresses')
    },

    methods: {
        deleteItem(v) {
            HTTP.delete(`contractors_addresses/`, {
                    params: {
                        id: v.id
                    }
                })
                .then(response => {
                    if (response.status == 200 && response.data && response.data.status == 'ok') {

                        this.snackbarText = 'Успiшно видалено'
                        this.snackbarColor = 'info'
                        this.snackbarIcon = 'done_outline'
                        this.getDataFromApi()
                    } else {
                        this.snackbarText = 'Помилка ' + (response.data.error && response.data.error.code ? response.data.error.code : '500')
                        this.snackbarColor = 'error'
                        this.snackbarIcon = 'error'
                    }

                }).catch(e => {
                    this.snackbarText = 'Помилка: 500'
                    this.snackbarColor = 'error'
                    this.snackbarIcon = 'error'
                })
                .finally(
                    () => {
                        this.snackbar = true
                    }
                )
        },
        cancelGroup() {
            this.group = null
            this.getDataFromApi()
        },
        getLocalStorage(f) {
            return JSON.parse(localStorage[f])
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        querySelectionsCity(v) {
            if (this.searchCity.length > 2) {

                this.loadingCity = true
                HTTP.get(`/layout/search_city/?q=` + this.searchCity)
                    .then(response => {
                        if (response.status == 200 && response.data && response.data.data) {
                            this.itemsCity = response.data.data
                        }
                    })
                    .catch(e => {
                        this.error.push(e)
                    })
                    .finally(
                        () => {
                            this.loadingCity = false
                        }
                    )
            }

        },
        getDataFromApi() {
            this.loading = true
            const {
                sortBy,
                descending,
                page,
                rowsPerPage
            } = this.pagination

            this.setLocalStorage('paginationContractorsAddresses', this.pagination)

            let items = this.list
            const total = items.length

            if (this.pagination.sortBy) {
                items = items.sort((a, b) => {
                    const sortA = a[sortBy]
                    const sortB = b[sortBy]

                    if (descending) {
                        if (sortA < sortB) return 1
                        if (sortA > sortB) return -1
                        return 0
                    } else {
                        if (sortA < sortB) return -1
                        if (sortA > sortB) return 1
                        return 0
                    }
                })
            }
            if (rowsPerPage > 0) {
                items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
            }
            HTTP.get(`contractors_addresses/list`, {
                    params: {
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        page: this.pagination.page,
                        rowsPerPage: this.pagination.rowsPerPage,
                        query: this.query,
                        city: this.city
                    }
                })
                .then(response => {
                    if (response.data) {
                        this.list = response.data.data
                        this.totalList = Number(response.data.total)
                    }
                })
                .catch(e => {
                    this.error.push(e)
                })
                .finally(
                    () => {
                        this.loading = false
                    }
                )

        }
    }

}
</script>
